// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"43ed34d5","382":"43ed34d5"}[chunkId] + ".chunk.css";
};